export default __webpack_public_path__ + "static/opdemo2-audio-companion-ec583f24793f475ec7963d6ff4d98511.png";